import styled from 'styled-components/native';
import Modal from 'react-native-modal';

export const ModalArea = styled(Modal)`
  margin: 0px;
  z-index: 99999;
`;
